'use strict'
import { has, get } from 'lodash-es'
import { Toast } from 'vant'
import Loader from '@/utils/loader'

const actions = {
  // 取得话题资讯、列表
  async getTopicData({ state, rootGetters, commit }, { page = 1, pageSize = 20, option = '', topic_id = ''  } = {}) {
    if (!option || !topic_id) return
    Loader.loading()
    const params = {
      topic_id,
      option,
      page,
      page_size: pageSize
    }
    const { getTopicPostsAPI } = await import('@/api/')
    const response = await getTopicPostsAPI(params)
    Loader.cancel()
    if (response?.body?.topic_info) {
      commit('setTopicInfo', response.body.topic_info || {})
    }
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info?.total || 0, // 总笔数
        page: response.body.page_info?.current_page || 1, // 第几页
        pages: response.body.page_info?.pages || 0, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.topicPostListData.list, ...result.list]
        commit('setTopicPostListData', {
          ...result,
          list: collageList
        })
      } else {
        commit('setTopicPostListData', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  //取得世界盃球料
  async getWorldCupData({ state, rootGetters, commit }, { page = 1, pageSize = 20, option = '', topic_id = ''  } = {}) {
    Loader.loading()
    const params = {
      topic_id,
      option,
      page,
      page_size: pageSize
    }
    try {
      const { getWorldCupDataAPI } = await import('@/api/')
      const { head, body } = await getWorldCupDataAPI()
      const validate = [head[0], body[0]]
      if(head.errCode !== 0 ) {
        throw new Error(head.errMsg)
      }
      commit('setTopicPostListData',
        { list: body.list, total: body.page_info.total || 0, page: body.page_info.current_page || 1 , pages: body.page_info.pages || 0 })
      Loader.cancel()
    } catch (error) {
      commit('setTopicPostListData', { list:[], pages: 0 })
      Loader.cancel()
    }


  }
}

export default actions
